<template>
  <section class="section-auth p-tb-25 bg-lighter">
    <div class="container-mini">
      <div class="text-center m-b-25">
        <router-link :to="{ name: 'home' }">
          <img src="../../assets/images/logo-color.png" alt="Logo" class="h-65" />
        </router-link>
      </div>

      <slot />

      <div class="text-center">
        <p>PT. ADIRA DINAMIKA MULTIFINANCE TBK &copy; {{ new Date().getFullYear() }}</p>
        <p class="social m-reset">
          <a href="//www.facebook.com/dicicilaja" target="_blank" class="p-r-10">
            <i class="fa fa-facebook bg-light social-facebook"></i>
          </a>
          <a href="//www.instagram.com/dicicilaja" target="_blank">
            <i class="fa fa-instagram bg-light social-instagram"></i>
          </a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

